<template>
	<transition name="el-fade-in-linear">
		<div class="page-content" v-show='show'>
			<header class="content-title" v-if='showTitle'>
			    <slot name='content-title'></slot>
			</header>
			<section class="content-body" :style='{
				"height": showTitle ? "calc(100% - 49px)" : "100%",
				"background": bodyColor
			}'>
				<div class="content-label">
					<div class="label-title-box" 
						:class="{'have-label-title': showTitle}"
						v-if='showLabel'
					>
						<slot name='label-title'></slot>
					</div>
					<el-scrollbar :style='{"height": showLabel ? "calc(100% - 34px)" : "100%"}'>
						<div class="label-body">
							<slot name='content-body'></slot>
						</div>
					</el-scrollbar>
				</div>
			</section>
		</div>
	</transition>
</template>
<script>
	export default {
		name:'page-body',
		props:['hide-label','hide-title','body-color'],
		data(){
			let me = this;
			
		 	let showLabelVal;
		 	let showTitleVal;

		 	showTitleVal = (me.hideTitle === "" || !!me.hideTitle) ? false : true;
			showLabelVal = (me.hideLabel === "" || !!me.hideLabel) ? false : true;
			return {
				showTitle:showTitleVal,
				showLabel: showLabelVal,
				show:true
			}
		}
	}
</script>

<style>
	.special-margin{
		margin:0 -10px;
		padding: 0 10px;
		border-bottom-color:#ddd 
	}
</style>



// WEBPACK FOOTER //
// src/components/content-body.vue